import { Badge, PageHeader } from '@/components';
import { useAuth } from '@/features/auth/AuthProvider';
import { ProfileForm } from '@/features/profile/ProfileForm';
import { welcomeForced } from '@/stores/welcome.store';
import { For, Show } from 'solid-js';

export default function ProfilePage() {
  const { session } = useAuth();

  return (
    <section>
      <PageHeader title="Profile" />
      <div class="mx-auto max-w-6xl p-6">
        <Show when={session()} keyed>
          {(s) => (
            <div class="flex flex-col gap-6">
              <Show when={s.mustSetName || welcomeForced()}>
                <div class="rounded-xl border border-brand-200 border-l-4 border-l-brand-600 bg-surface p-6 shadow-sm transition-opacity duration-200 ease-out starting:opacity-0 motion-reduce:transition-none dark:border-brand-900 dark:border-l-brand-500 dark:bg-surface-dark">
                  <h2 class="font-semibold text-neutral-900 dark:text-neutral-100">ยินดีต้อนรับ! 👋</h2>
                  <p class="mt-1 text-sm text-neutral-600 dark:text-neutral-400">
                    Welcome to the team. Please set your display name below to continue — it's how
                    everyone will see you across the app.
                  </p>
                </div>
              </Show>
              <div class="flex flex-col gap-6 rounded-xl border border-neutral-100 bg-surface p-6 shadow-sm dark:border-neutral-800 dark:bg-surface-dark">
                <dl class="flex flex-col gap-3 text-sm">
                  <div>
                    <dt class="font-medium text-neutral-500">Email</dt>
                    <dd class="mt-0.5 text-neutral-900 dark:text-neutral-100">{s.email}</dd>
                  </div>
                  <div>
                    <dt class="font-medium text-neutral-500">Roles</dt>
                    <dd class="mt-1 flex flex-wrap gap-1.5">
                      <For each={s.roles}>{(role) => <Badge>{role.name}</Badge>}</For>
                    </dd>
                  </div>
                </dl>
                <ProfileForm
                  initialName={s.displayName}
                  initialGithub={s.githubUsername}
                  locked={s.githubUsernameLocked}
                  verifiedGithub={
                    s.githubUsername
                      ? {
                          login: s.githubUsername,
                          name: s.githubName,
                          avatarUrl: s.githubAvatarUrl,
                        }
                      : null
                  }
                />
              </div>
            </div>
          )}
        </Show>
      </div>
    </section>
  );
}
